export default __webpack_public_path__ + "static/media/CA-1 Click Apps.747575bd.png";